import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import React from 'react';
import Markdown from 'markdown-to-jsx';
import { css, jsx } from '@emotion/react';
var AISummaryCSS = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow-y: auto;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  word-wrap: break-word;\n  white-space: normal;\n"])));
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */

var AISummary = function AISummary(_ref) {
  var content = _ref.content,
    overrideCss = _ref.overrideCss,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'ai-summary' : _ref$testId;
  if (!content) {
    return null;
  }
  return jsx(Markdown, {
    "data-testid": testId,
    css: [AISummaryCSS, overrideCss],
    children: content,
    options: {
      forceWrapper: true
    }
  });
};
export default AISummary;